import { FwdRollMutableRowModel } from "app/bfx-blotter-intervention/fwd-roll-pricing/models/FwdRollMutableRowModel";
import { FwdRollPortfolioModel } from "app/bfx-blotter-intervention/fwd-roll-pricing/models/FwdRollPortfolioModel";
import {
  BigNumber,
  FwdRollOrderAllocationPricingImpl,
  FwdRollRowType,
  Tenor,
} from "shared/cubiq-model-multi-asset";

export class FwdRollAllocationModel
  extends FwdRollOrderAllocationPricingImpl
  implements FwdRollMutableRowModel
{
  public ptsPrecision: number;

  public ptsMultiplier: BigNumber;

  minPrecision: number;

  /* For Change detection */
  primedMarketForwardPts: BigNumber;
  primedClientForwardPts: BigNumber;
  primedFwdMarkup: BigNumber;

  reqForwardPts: BigNumber | null;
  failedAdjCalculation: boolean;

  public isMarketPtsChanged: boolean;
  public isClientPtsChanged: boolean;
  public isFwdMarkupChanged: boolean;
  public lockedForUserPricing: boolean;

  public isEditorDisabled: boolean = false;

  constructor(private portfolioModel: FwdRollPortfolioModel) {
    super();
  }

  public get rowType() {
    return FwdRollRowType.ORDER;
  }

  public get isChanged(): boolean {
    return this.isMarketPtsChanged || this.isClientPtsChanged || this.isFwdMarkupChanged;
  }

  /**
   * Can this row be edited?
   */
  public get isEditable(): boolean {
    const canEdit = !this.portfolioModel.disabled && this.settleTenor !== Tenor.SPOT;
    return canEdit;
  }

  /**
   * Can this row markup be edited?
   */
  public get isMarkupEditable(): boolean {
    return true;
  }

  /**
   * Does this model support blotter selection? Should be true only for non-spot dealt pair rows
   */
  public get supportsSelection(): boolean {
    return false;
  }

  public get marketForwardPtsScaled(): BigNumber {
    return this.marketForwardPts?.div(this.ptsMultiplier);
  }

  public get clientForwardPtsScaled(): BigNumber {
    return this.clientForwardPts?.div(this.ptsMultiplier);
  }

  public get forwardMarkupScaled(): BigNumber {
    return this.fwdMarkup?.div(this.ptsMultiplier);
  }

  public get reqForwardPtsScaled(): BigNumber {
    return this.reqForwardPts?.div(this.ptsMultiplier);
  }

  public updateMarketForwardPts(value: BigNumber): boolean {
    return this.portfolioModel.updateMarketForwardPts(this, value);
  }

  updateClientForwardPts(value: BigNumber): boolean {
    return this.portfolioModel.updateClientForwardPts(this, value);
  }

  updateForwardMarkup(value: BigNumber): boolean {
    return this.portfolioModel.updateForwardMarkup(this, value);
  }

  public get intent() {
    return this.clientIntent;
  }

  recalcCounterAmount(): string {
    if (this.fixedCcy == this.baseCcy) {
      this.counterAmt = this.fixedAmt.times(this.clientForwardRate);
    } else {
      this.counterAmt = this.fixedAmt.dividedBy(this.clientForwardRate);
    }
    return "counterAmt";
  }
}
